import { Component, OnInit } from '@angular/core';
import { Global } from "../global";
import { Components } from "../shared/components/components";
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router";
import { Funcoes } from "../funcoes";
import { LoginService } from "../login/login.service";
import { TipoUnidadeService } from "../laudos-cd/tipo-unidade.service";
import { TipoUnidadeModel } from "../laudos-cd/tipo-unidade.model";

declare var swal: any;

@Component({
  selector: 'app-tipo-unidade',
  templateUrl: './tipo-unidade.component.html'
})
export class TipoUnidadeComponent extends Components implements OnInit {

  tiposUnidade: TipoUnidadeModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService,
    private tipoUnidadeService: TipoUnidadeService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].id_acao == '24'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.getPage(1);
  }

  getPage(page: number) {
    this.paginaAtual = page;
    this.carregandoTabela = true;
    this.tipoUnidadeService.getPaginacao(page, this.itensPorPagina).subscribe(json => {
      this.tiposUnidade = json.Payload.data;
      this.totalItens = json.Payload.total;
      this.carregandoTabela = false;
    }, error => {
      this.func.showErro(error.json());
      this.carregandoTabela = false;
    });
  }

  delete(tipoUnidade: TipoUnidadeModel) {
    let self = this;
    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarTipoUnidade') + tipoUnidade.nome_pt + '?',
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        self.tipoUnidadeService.apagar(tipoUnidade.id).subscribe(data => {
          self.getPage(self.paginaAtual);
        }, error => {
          self.func.showErro(error.json());
        });
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/tipo-unidade/tipo-unidade.component.ts